import resources from '@/locales/fr/translation.json'
import { I18nHelper } from '@meltingpoint/lastmile-internationalization'
import VueI18Next from '@panter/vue-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import Vue from 'vue'
import { dateHelper } from '../helpers/dateHelper'

Vue.use(VueI18Next)

export const AVAILABLE_LANGUAGES = [
  'fr',
  'en',
  'nl-be',
  'it',
  'es',
  'ca',
  'de',
  'pt',
  'sk',
  'cz',
  'cs',
  'hu',
]

export const TRANSLATED_LANGUAGES: { [key: string]: string } = {
  fr: 'Français',
  en: 'English (UK)',
  'nl-be': 'Vlaams',
  es: 'Español',
  it: 'Italiano',
  ca: 'Català',
  de: 'Deutsche',
  pt: 'Português',
  sk: 'slovenčina',
  cz: 'čeština',
  cs: 'čeština',
  hu: 'magyar',
}

let i18n: I18nHelper

const getI18nHelper = (configUrl?: string) => {
  if (i18n) {
    return i18n
  }

  const path = '/locales/{{lng}}/{{ns}}.json'
  const url = `${configUrl}${path}`

  i18n = new I18nHelper(
    {
      fallbackLng: 'fr',
      detection: {
        order: [
          'querystring',
          'cookie',
          'localStorage',
          'sessionStorage',
          'navigator',
          'htmlTag',
          'path',
          'subdomain',
        ],
      },
      load: 'currentOnly',
      lowerCaseLng: true,
      backend: {
        crossDomain: true,
        loadPath: url,
        expirationTime: 1 * 60 * 60 * 1000,
      },
    },
    [Backend, LanguageDetector],
  )

  setTimeout(() => {
    // Load local if remote translation file failed
    if (!i18n.hasLanguageResources('fr')) {
      i18n.addResource({ language: 'fr', resources })
    }

    dateHelper.changeLocale(i18n.getLanguageCode())
  }, 1)

  return i18n
}

export const loadI18n = (url: string) => {
  const localI18nHelper = getI18nHelper(url)

  return new VueI18Next(localI18nHelper.getI18next() as any)
}

export { i18n }
